"use client"

import { useAnalyticsOptOut } from "@src/hooks/useAnalyticsOptOut"
import { useFirstActionLogger } from "@src/hooks/useFirstActionLogger"
import { useGtagBus } from "@src/hooks/useGtagBus"
import { useMixpanelBus } from "@src/hooks/useMixpanelBus"
import type { ReactNode } from "react"

export function TrackingProvider({ children }: { children: ReactNode }) {
  useAnalyticsOptOut()
  useMixpanelBus()
  useGtagBus()
  useFirstActionLogger()
  return children
}
